import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import io from 'socket.io-client';
import './Dashboard.css';
import SideBar from '../../components/SideBar/SideBar';
import ChatWindow from '../../components/chat/ChatWindow';
import { API_BASE } from '../../config/api';

export default function Dashboard() {
  const [isAuthChecked, setIsAuthChecked] = useState(false);
  const [selectedFriend, setSelectedFriend] = useState(null);
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [socket, setSocket] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
      return;
    }

    const userId = localStorage.getItem('userId'); // directly get userId
    if (!userId) {
      navigate('/login');
      return;
    }

    setIsAuthChecked(true);

    // Connect to Socket.io server
    const newSocket = io(API_BASE, {
      query: { userId } // send userId as query
    });

    setSocket(newSocket);

    newSocket.emit('join', userId);

    newSocket.on('onlineUsers', (data) => {
      console.log('Online users:', data);
      setOnlineUsers(data);
    });

    newSocket.on('receiveMessage', (message) => {
      console.log('New message:', message);
      // You can handle incoming messages here if needed
    });

    return () => newSocket.disconnect();
  }, [navigate, API_BASE]);

  if (!isAuthChecked) return null;

  return (
    <div className="dashboard-container">
      <SideBar
        setSelectedFriend={setSelectedFriend}
        onlineUsers={onlineUsers}
      />
      <ChatWindow
        friend={selectedFriend}
        onClose={() => setSelectedFriend(null)}
        socket={socket}
        onlineUsers={onlineUsers}
      />
    </div>
  );
}
